import React from "react";
export type ClientLogos = Record<string, string>;

const clientLogos: ClientLogos = {
  andqo:
    "https://d3r4kok9l4jqdh.cloudfront.net/fit-in/160x160/filters:fill(white)/company/64352de3870cf.png",
  sncf: "https://www.1min30.com/wp-content/uploads/2018/01/SNCF-logo-1.jpg",
};

export default clientLogos;
